/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { IFooterCategoryViewProps } from './footer-category';

export const FooterCategoryView: React.FC<IFooterCategoryViewProps> = props => {
    const { categories, FooterList, FooterListItem } = props;
    if (!categories || categories.length === 0) {
        props.context.telemetry.error('Footer content is empty, module wont render');
        return null;
    }
    return (
        <Module {...FooterList}>
            {categories.map((category: ReactNode, index: number) => {
                return (
                    <Node {...FooterListItem} key={index}>
                        {category}
                    </Node>
                );
            })}
        </Module>
    );
};

export default FooterCategoryView;
